import { render, staticRenderFns } from "./FormAnchor.vue?vue&type=template&id=b2ae83bc"
import script from "./FormAnchor.vue?vue&type=script&lang=js"
export * from "./FormAnchor.vue?vue&type=script&lang=js"
import style0 from "./FormAnchor.vue?vue&type=style&index=0&id=b2ae83bc&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports